<!--
  «La solicitud» (CONTRATO-REDISENO-ALTAS.md, pantalla A). De arriba abajo y a todo el ancho: la
  cabecera con el riel del workflow (fija bajo la barra de 64 px), «Tarea actual» con UN botón
  principal, y las pestañas Expediente (solo lectura) · Historial · Decisión. Aquí no se edita nada
  del expediente: eso vive en «Cargar el expediente» / «Cargar las condiciones» (/console/altas/:id/cargar).
-->
<div class="kb-page kb-gateway">

  <nav class="kb-migas" aria-label="Ubicación">
    <a class="kb-miga" [routerLink]="['/console/altas']">Altas de comercios</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <span class="kb-miga-actual">{{ sol?.numero || 'Solicitud' }}</span>
  </nav>

  <div class="space-y-6" *ngIf="cargando" aria-hidden="true">
    <div class="kb-skeleton h-9 w-1/3"></div>
    <div class="kb-skeleton h-56 w-full"></div>
  </div>
  <p class="sr-only" *ngIf="cargando">Cargando la solicitud.</p>

  <!-- No existe: es un hecho, no un fallo -->
  <div class="kb-aviso kb-aviso-info" *ngIf="!cargando && !sol && noExiste">
    <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
    <div>
      <p class="kb-aviso-titulo">Esa solicitud no existe</p>
      <p>Puede que se haya movido o que el número esté mal escrito. Las que hay están en la bandeja.</p>
      <a class="kb-btn kb-btn-outline kb-btn-sm mt-3 !text-foreground" [routerLink]="['/console/altas']">Ir a la bandeja</a>
    </div>
  </div>
  <!-- Falló la consulta: se puede reintentar -->
  <div class="kb-aviso kb-aviso-peligro" *ngIf="!cargando && !sol && !noExiste && error">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
    <div>
      <p class="kb-aviso-titulo">No se pudo abrir la solicitud</p>
      <p>{{ error }}</p>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3" (click)="cargar()">
        <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar
      </button>
    </div>
  </div>

  <ng-container *ngIf="!cargando && sol">

    <!-- ══ 1 · Cabecera + riel del workflow, fija bajo la barra ══════════════════════════════════ -->
    <header class="as-cabeza">
      <div class="as-cabeza-titulo">
        <h1 class="kb-page-title flex flex-wrap items-center gap-2">
          {{ sol.datos.nombre_comercial || sol.numero }}
          <span class="kb-badge kb-badge-contorno">{{ sol.numero }}</span>
          <span class="kb-badge" [ngClass]="etapaInsignia?.clase || ''" *ngIf="etapaInsignia">{{ etapaInsignia?.texto }}</span>
        </h1>
        <p class="kb-page-meta">
          Solicitud de alta: por dónde va, lo que te toca y el expediente.
          <ng-container *ngIf="mandadaPor"> {{ mandadaPor }}</ng-container>
        </p>
      </div>
      <app-riel-pasos class="as-cabeza-riel" [pasos]="pasosRiel" [rotulo]="'Etapas del workflow «' + sol.tipo_nombre + '»'"></app-riel-pasos>
    </header>

    <!-- ══ Avisos de las acciones ════════════════════════════════════════════════════════════ -->
    <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
      <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
      <div>
        <p>{{ error }}</p>
        <ul class="mt-1 list-disc pl-5" *ngIf="detalle.length > 1"><li *ngFor="let d of detalle">{{ d }}</li></ul>
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3" (click)="cargar()">
          <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar
        </button>
      </div>
    </div>
    <div class="flex flex-wrap items-center gap-2" *ngIf="aviso">
      <p class="text-sm font-medium kb-texto-exito" role="status">{{ aviso }}</p>
      <a class="kb-btn kb-btn-outline kb-btn-sm !text-foreground" *ngIf="avisoConVolver" [routerLink]="['/console/altas']">Volver a la bandeja</a>
    </div>

    <!-- ══ 2 · Lo que te toca (Juan, 2026-10-08: arriba qué te toca y desde cuándo; los puntos de la
         etapa con su ✓; la acción principal destacada; Liberar en el «⋯»; explicaciones en tooltip) ══ -->
    <section class="as-tarea" *ngIf="franja" aria-labelledby="asFranjaRotulo">
      <div class="as-tarea-cab">
        <div class="as-tarea-quien">
          <h2 class="as-tarea-titulo" id="asFranjaRotulo">
            {{ franja.rotulo }}
            <span class="as-tarea-info" *ngIf="franja.tarea" tabindex="0" [attr.data-kb-tip]="franja.tarea" aria-label="Qué se hace en esta etapa">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
            </span>
          </h2>
          <p class="as-tarea-linea"
             [class.kb-texto-exito]="franja.tono === 'exito'" [class.kb-texto-alerta]="franja.tono === 'alerta'"
             [class.kb-texto-peligro]="franja.tono === 'peligro'">{{ franja.linea }}</p>
          <p class="as-tarea-linea" *ngIf="franja.extra">«{{ franja.extra }}»</p>
        </div>

        <div class="as-tarea-acciones" *ngIf="franja.principal || franja.secundaria || franja.soltar">
          <button type="button" class="kb-btn kb-btn-outline" *ngIf="franja.secundaria === 'DECIDIR'" (click)="irA('decision')"
                  data-kb-tip="Aprobar, devolver o rechazar la solicitud">Decidir</button>
          <button type="button" class="kb-btn kb-btn-outline" *ngIf="franja.secundaria === 'REVISAR'" (click)="irA('expediente')">Revisar la ficha</button>

          <button type="button" class="kb-btn kb-btn-primary" *ngIf="franja.principal === 'TOMAR'" (click)="tomar()" [disabled]="tomando"
                  data-kb-tip="Queda a tu nombre y nadie más la puede trabajar">
            <i class="fas fa-spinner fa-spin" *ngIf="tomando" aria-hidden="true"></i>Asignarme
          </button>
          <a class="kb-btn kb-btn-primary" *ngIf="franja.principal === 'CONTINUAR'" [routerLink]="['/console/altas', id, 'cargar']">{{ textoPrincipal }}</a>
          <button type="button" class="kb-btn kb-btn-primary" *ngIf="franja.principal === 'DECIDIR'" (click)="irA('decision')">Decidir</button>

          <!-- El efecto de la aprobación (contrato CONTRATO-ALTA-AUTOMATICA.md §2) -->
          <a class="kb-btn kb-btn-primary" *ngIf="franja.principal === 'VER_COMERCIO' && sol.efecto?.detalle?.comercio as comercio"
             [routerLink]="['/console/merchants', comercio.code]">Ver el comercio</a>
          <button type="button" class="kb-btn kb-btn-primary" *ngIf="franja.principal === 'REINTENTAR_ALTA'" (click)="reintentarAlta()" [disabled]="reintentando">
            <i class="fas fa-spinner fa-spin" *ngIf="reintentando" aria-hidden="true"></i>Reintentar el alta
          </button>

          <app-kb-menu *ngIf="franja.soltar" [opciones]="opcionesFranja" [deshabilitado]="soltando" (elegir)="menuFranja($event)"></app-kb-menu>
        </div>
      </div>

      <ol class="as-tarea-puntos" *ngIf="franja.puntos.length">
        <li class="as-punto" *ngFor="let p of franja.puntos" [class.as-punto-hecho]="p.hecho" [class.as-punto-falta]="p.falta">
          <i class="as-punto-marca" [ngClass]="p.hecho ? 'fas fa-check-circle kb-texto-exito' : 'far fa-circle'" aria-hidden="true"></i>
          <div>
            <div class="as-punto-nombre">{{ p.nombre }}<span class="sr-only">{{ p.hecho ? ' (listo)' : ' (pendiente)' }}</span></div>
            <div class="as-punto-detalle" [class.kb-texto-alerta]="p.falta">{{ p.detalle }}</div>
          </div>
        </li>
      </ol>
    </section>

    <!-- ══ 3 · Pestañas ═══════════════════════════════════════════════════════════════════════ -->
    <div class="kb-tabs-list" role="tablist" aria-label="Partes de la solicitud">
      <button type="button" role="tab" id="asTabExpediente" class="kb-pestana" [class.kb-pestana-activa]="pestana === 'expediente'"
              [attr.aria-selected]="pestana === 'expediente'" aria-controls="asPanel" (click)="irA('expediente')">Ficha</button>
      <button type="button" role="tab" id="asTabHistorial" class="kb-pestana" [class.kb-pestana-activa]="pestana === 'historial'"
              [attr.aria-selected]="pestana === 'historial'" aria-controls="asPanel" (click)="irA('historial')">
        Historial <span class="kb-pestana-num">{{ eventos.length }}</span>
      </button>
      <button type="button" role="tab" id="asTabDecision" class="kb-pestana" [class.kb-pestana-activa]="pestana === 'decision'"
              [attr.aria-selected]="pestana === 'decision'" aria-controls="asPanel" (click)="irA('decision')">Decisión</button>
    </div>

    <div id="asPanel" role="tabpanel" class="as-panel"
         [attr.aria-labelledby]="pestana === 'historial' ? 'asTabHistorial' : pestana === 'decision' ? 'asTabDecision' : 'asTabExpediente'">

      <!-- ─── Expediente: solo lectura ─────────────────────────────────────────────────────── -->
      <ng-container *ngIf="pestana === 'expediente'">
        <p class="as-panel-intro">Lo que se sabe del comercio. Aquí solo se lee: cada perfil carga su parte con «Cargar el expediente» o «Cargar las condiciones».</p>

        <!-- Puesta en marcha (CONTRATO-PUESTA-EN-MARCHA.md, «D»): sólo una vez aprobada, arriba de todo. -->
        <div class="kb-card" *ngIf="sol.estado === 'APROBADA' && sol.puesta_en_marcha">
          <div class="kb-card-header">
            <p class="kb-seccion-rotulo">Puesta en marcha</p>
          </div>
          <div class="kb-card-body">
            <!-- La escena animada (CONTRATO-PUESTA-EN-MARCHA.md, «cambio en vivo»): el nombre y el
                 código del comercio que nació; si todavía no nació, el nombre de la solicitud y sin
                 código. El `*ngIf` de la tarjeta ya frena en `sol.puesta_en_marcha`. -->
            <!-- Juan (2026-09-28): al final se ve SOLO lo que falló; eso lo pinta la escena debajo de sí
                 misma, con su «Reintentar». La lista completa `<app-puesta-en-marcha>` sale de esta vista
                 (el componente queda). -->
            <app-puesta-en-marcha-escena [puesta]="sol.puesta_en_marcha"
                [comercio]="{ nombre: sol.efecto?.detalle?.comercio?.name || sol.datos.nombre_comercial || sol.numero, codigo: sol.efecto?.detalle?.comercio?.code }"
                [puedeReintentar]="!!sol.acciones.reintentar_puesta_en_marcha"
                [ocupado]="reintentandoPuestaEnMarcha || !!reintentandoPaso"
                (reintentarPaso)="reintentarPasoClick($event)"
                (completarPaso)="abrirCompletarDomicilio()"
                (reintentarTodo)="reintentarPuestaEnMarcha()">
            </app-puesta-en-marcha-escena>
            <!-- Un paso falló por el domicilio fiscal incompleto: se completa ahí mismo y se reintenta. -->
            <div class="mt-3" *ngIf="completandoDomicilio">
              <p class="text-sm font-medium text-foreground">Completar el domicilio fiscal</p>
              <div class="mt-2" *ngFor="let p of PIEZAS_FISCAL">
                <label class="kb-label" [for]="'asDom_' + p.clave">{{ p.rotulo }} <span class="kb-texto-peligro" *ngIf="p.obligatorio">*</span></label>
                <input [id]="'asDom_' + p.clave" type="text" class="kb-input" [(ngModel)]="formDomicilio[p.clave]">
              </div>
              <p class="text-sm kb-texto-peligro mt-2" *ngIf="errorDomicilio">{{ errorDomicilio }}</p>
              <div class="flex flex-wrap items-center gap-2 mt-3">
                <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" [disabled]="guardandoDomicilio || !domicilioListo" (click)="guardarYReintentarDomicilio()">
                  <i class="fas fa-spinner fa-spin" *ngIf="guardandoDomicilio" aria-hidden="true"></i>Guardar y reintentar
                </button>
                <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" [disabled]="guardandoDomicilio" (click)="cancelarCompletarDomicilio()">Cancelar</button>
              </div>
            </div>
            <p class="kb-hint mt-2" *ngIf="reintentandoPuestaEnMarcha"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Reintentando…</p>
            <p class="kb-hint mt-2" *ngIf="reintentandoPaso"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Reintentando ese paso…</p>

            <!-- URL propia (maqueta aprobada): el paso «Dirección propia del portal» con sus cuatro estados
                 (preparando · lista · falló · no aplica en este ambiente) y «Probar dirección». -->
            <div class="flex items-start gap-3 border-t border-border py-3 mt-3" *ngIf="pasoDireccion as pd">
              <span class="mt-0.5 shrink-0 text-base" aria-hidden="true"
                    [class.kb-texto-exito]="pd.estado === 'VERIFICADO' || pd.estado === 'HECHO'"
                    [class.kb-texto-peligro]="pd.estado === 'FALLO'"
                    [class.text-muted-foreground]="pd.estado === 'PENDIENTE' || pd.estado === 'EN_CURSO' || pd.estado === 'NO_APLICA'">
                <i class="fas fa-check-circle" *ngIf="pd.estado === 'VERIFICADO' || pd.estado === 'HECHO'"></i>
                <i class="fas fa-times-circle" *ngIf="pd.estado === 'FALLO'"></i>
                <i class="fas fa-spinner fa-spin" *ngIf="pd.estado === 'EN_CURSO'"></i>
                <i class="far fa-circle" *ngIf="pd.estado === 'PENDIENTE'"></i>
                <i class="fas fa-minus-circle" *ngIf="pd.estado === 'NO_APLICA'"></i>
              </span>
              <div class="min-w-0 flex-1">
                <p class="text-sm font-medium" [class.kb-texto-peligro]="pd.estado === 'FALLO'"
                   [class.text-muted-foreground]="pd.estado === 'PENDIENTE' || pd.estado === 'NO_APLICA'">
                  Dirección propia del portal
                  <span class="text-muted-foreground font-normal" *ngIf="pd.estado === 'EN_CURSO'">— Preparando el certificado…</span>
                  <span class="kb-dato-nota" *ngIf="pd.estado === 'NO_APLICA'">no aplica en este ambiente</span>
                </p>
                <p class="mt-0.5 break-all font-mono text-xs text-muted-foreground"
                   *ngIf="hostDireccion && (pd.estado === 'EN_CURSO' || pd.estado === 'VERIFICADO' || pd.estado === 'HECHO')">{{ hostDireccion }}</p>
                <p class="mt-0.5 text-xs text-muted-foreground" *ngIf="pd.estado === 'EN_CURSO'">Google tarda unos minutos en emitir el certificado. No hace falta esperar: el resto sigue.</p>
                <p class="mt-0.5 text-xs text-muted-foreground" *ngIf="pd.estado === 'VERIFICADO' || pd.estado === 'HECHO'">Lista: responde con candado.</p>
                <p class="mt-0.5 text-xs kb-texto-peligro" *ngIf="pd.estado === 'FALLO'">{{ pd.error || pd.detalle || 'Google no aceptó crear la dirección. Avisa a infraestructura y reintenta.' }}</p>
                <p class="mt-0.5 text-xs text-muted-foreground" *ngIf="pd.estado === 'NO_APLICA'">{{ pd.detalle }}</p>
              </div>
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm shrink-0"
                      *ngIf="pd.estado === 'EN_CURSO' && sol.efecto?.detalle?.comercio?.code"
                      [disabled]="probandoDireccion" (click)="probarDireccion()">Probar dirección</button>
            </div>
          </div>
        </div>

        <!-- Credenciales del comercio (CONTRATO-PUESTA-EN-MARCHA.md, «K»): se arman AL ENTREGAR y
             no se guardan — por eso confirma en la misma página, sin modal, antes de rotar las
             claves. Debajo de la escena, no adentro: `app-puesta-en-marcha-escena` no se toca. -->
        <div class="kb-card" *ngIf="sol.acciones.entregar_credenciales">
          <div class="kb-card-header">
            <p class="kb-seccion-rotulo">Credenciales</p>
          </div>
          <div class="kb-card-body">
            <!-- Juan, 2026-10-19: un usuario del portal por acceso (administración, gerente, caja), con a quién se le mandó su clave -->
            <ng-container *ngIf="accesos.length > 1">
              <p class="kb-hint">Al aprobarse el alta nacieron {{ accesos.length === 3 ? 'tres' : accesos.length }} usuarios del portal. Cada persona recibe su clave temporal por correo (la de la caja le llega al gerente); aquí se ve a quién se le mandó y cuándo. Nadie de CrediTotal ve las claves: sólo salen en el PDF.</p>
              <div class="kb-tabla-plana mt-3">
                <table class="kb-table">
                  <thead class="kb-thead"><tr>
                    <th class="kb-th">Usuario del portal</th><th class="kb-th">Papel</th><th class="kb-th">Se le mandó a</th><th class="kb-th">Estado</th><th class="kb-th"><span class="sr-only">Acción</span></th>
                  </tr></thead>
                  <tbody>
                    <ng-container *ngFor="let a of accesos">
                      <tr class="kb-tr">
                        <td class="kb-td kb-td-titulo font-mono">{{ a.username }}</td>
                        <td class="kb-td">{{ papelDelAcceso(a) }}</td>
                        <td class="kb-td">
                          <ng-container *ngIf="a.envio_estado === 'enviado'; else seEnviara">{{ a.correo }}</ng-container>
                          <ng-template #seEnviara><span class="kb-td-sub">Se enviará a {{ a.correo }}</span></ng-template>
                        </td>
                        <td class="kb-td" [ngSwitch]="a.envio_estado">
                          <span *ngSwitchCase="'enviado'" class="kb-badge kb-badge-exito"><i class="fas fa-check" aria-hidden="true"></i> Enviada el {{ fechaHora(a.enviado_en) }}</span>
                          <span *ngSwitchDefault class="kb-badge kb-badge-contorno"><i class="fas fa-clock" aria-hidden="true"></i> Pendiente de enviar</span>
                        </td>
                        <td class="kb-td">
                          <div class="flex justify-end" *ngIf="puedeRenovarAccesos && a.activo">
                            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [attr.aria-label]="'Renovar la clave de ' + a.username"
                                    [disabled]="renovandoAcceso || confirmandoRenovar === a.usuario_id" (click)="pedirRenovar(a)">
                              <i class="fas fa-redo" aria-hidden="true"></i> Renovar
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr class="kb-tr" *ngIf="confirmandoRenovar === a.usuario_id">
                        <td class="kb-td" colspan="5">
                          <div class="flex flex-wrap items-center justify-end gap-2">
                            <span class="text-sm kb-texto-peligro">Se renueva la clave de {{ a.username }}: la anterior deja de servir. La nueva se manda por correo a {{ a.correo }}.</span>
                            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="renovandoAcceso" (click)="cancelarRenovar()">Cancelar</button>
                            <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" [disabled]="renovandoAcceso" (click)="confirmarRenovar(a)">
                              <i class="fas fa-spinner fa-spin" *ngIf="renovandoAcceso" aria-hidden="true"></i>Renovar y enviar
                            </button>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
              <p class="kb-hint mt-2" role="status">{{ avisoAccesos }}</p>
            </ng-container>
            <ng-container *ngIf="!confirmandoCredenciales; else confirmacionCredenciales">
              <p class="kb-hint" *ngIf="accesos.length <= 1">Se arman al descargarlas y no se guardan en ningún lado. Descargarlas de nuevo renueva las claves: las anteriores dejan de servir.</p>
              <div class="flex flex-wrap justify-end gap-2 mt-3">
                <button type="button" class="kb-btn kb-btn-outline" [disabled]="entregandoCredenciales" (click)="pedirEntregarCredenciales('acceso')">
                  <i class="fas fa-key" aria-hidden="true"></i> Credenciales de acceso<ng-container *ngIf="accesos.length === 3"> (PDF con las tres)</ng-container>
                </button>
                <button type="button" class="kb-btn kb-btn-outline" *ngIf="sol.acciones.credenciales_integracion" [disabled]="entregandoCredenciales" (click)="pedirEntregarCredenciales('integracion')">
                  <i class="fas fa-plug" aria-hidden="true"></i> Credenciales de integración
                </button>
              </div>
              <p class="kb-hint mt-2" *ngIf="accesos.length > 1">El PDF reúne {{ accesos.length === 3 ? 'las tres credenciales' : 'las credenciales' }} y se arma al descargarlo; no se guarda en ningún lado. Descargarlo renueva {{ accesos.length === 3 ? 'las tres claves' : 'todas las claves' }}. Para renovar sólo una, use «Renovar» en su fila. Las de integración, si el comercio las tiene, siguen aparte y son de uso interno de CrediTotal.</p>
              <p class="kb-hint mt-2" *ngIf="accesos.length <= 1">Las de acceso son para el comercio: el usuario y la clave temporal de su administrador en el portal. Las de integración son de uso interno de CrediTotal: dan acceso a la pasarela y no se le entregan al comercio.</p>
            </ng-container>
            <ng-template #confirmacionCredenciales>
              <div class="flex flex-wrap items-center justify-end gap-2">
                <span class="text-sm kb-texto-peligro" *ngIf="confirmandoCredenciales === 'acceso' && accesos.length <= 1">Se renueva la clave del administrador del portal: la que se entregó antes deja de servir.</span>
                <span class="text-sm kb-texto-peligro" *ngIf="confirmandoCredenciales === 'acceso' && accesos.length > 1">Se renuevan las claves de {{ accesos.length === 3 ? 'las tres personas' : 'todas las personas' }}: las anteriores dejan de servir, y a cada una le llega la nueva por correo.</span>
                <span class="text-sm kb-texto-peligro" *ngIf="confirmandoCredenciales === 'integracion'">Se renuevan la llave y la clave de la integración en la pasarela: el integrador tiene que usar las nuevas.</span>
                <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="entregandoCredenciales" (click)="cancelarEntregarCredenciales()">Cancelar</button>
                <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" [disabled]="entregandoCredenciales" (click)="confirmarEntregarCredenciales()">
                  <i class="fas fa-spinner fa-spin" *ngIf="entregandoCredenciales" aria-hidden="true"></i>Renovar y descargar
                </button>
              </div>
            </ng-template>
            <p class="kb-hint mt-2" *ngIf="credencialesEntregadasEn.acceso">Credenciales de acceso descargadas el {{ fechaHora(credencialesEntregadasEn.acceso) }}.</p>
            <p class="kb-hint mt-2" *ngIf="credencialesEntregadasEn.integracion">Credenciales de integración descargadas el {{ fechaHora(credencialesEntregadasEn.integracion) }}.</p>
          </div>
        </div>

        <!-- Datos del comercio -->
        <div class="kb-card">
          <div class="kb-card-header">
            <p class="kb-seccion-rotulo">Datos del comercio <span class="as-quien">los llena el {{ quienLlena('DATOS') }}</span></p>
            <a class="kb-btn kb-btn-outline kb-btn-sm !text-foreground" *ngIf="ofreceCompletar('DATOS')"
               [routerLink]="['/console/altas', id, 'cargar']" [queryParams]="{ paso: pasoDe('DATOS') }">Completar</a>
          </div>
          <div class="kb-card-body">
            <dl class="kb-campos">
              <div class="kb-campo"><dt class="kb-campo-et">Nombre comercial</dt><dd class="kb-campo-val">{{ sol.datos.nombre_comercial || '—' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Razón social</dt><dd class="kb-campo-val">{{ sol.datos.razon_social || '—' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">RIF</dt><dd class="kb-campo-val">{{ sol.datos.rif || '—' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Dirección fiscal</dt><dd class="kb-campo-val">{{ fiscalSol.street || '—' }}</dd></div>
              <ng-container *ngFor="let p of PIEZAS_FISCAL.slice(1)">
                <div class="kb-campo" *ngIf="fiscalSol[p.clave] || p.obligatorio"><dt class="kb-campo-et">{{ p.rotulo }}</dt><dd class="kb-campo-val">{{ fiscalSol[p.clave] || '—' }}</dd></div>
              </ng-container>
              <!-- Estos cuatro no son de los mínimos para nacer (nombre, razón social, RIF, dirección):
                   vacíos, dicen «(opcional)», no «—» (H-14). -->
              <div class="kb-campo"><dt class="kb-campo-et">Tipo de persona</dt><dd class="kb-campo-val">{{ sol.datos.tipo_persona === 'JURIDICA' ? 'Jurídica' : sol.datos.tipo_persona === 'NATURAL' ? 'Natural' : '(opcional)' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Teléfono</dt><dd class="kb-campo-val">{{ sol.datos.telefono || '(opcional)' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Correo</dt><dd class="kb-campo-val">{{ sol.datos.correo || '(opcional)' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Descripción</dt><dd class="kb-campo-val">{{ sol.datos.descripcion || '(opcional)' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Centros de beneficio</dt><dd class="kb-campo-val" [class.kb-texto-alerta]="!centrosTexto && sol.estado === 'EN_CURSO'">{{ centrosTexto || (sol.estado === 'EN_CURSO' ? 'Falta: al menos uno para aprobar' : '—') }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Tienda y caja</dt><dd class="kb-campo-val" [class.kb-texto-alerta]="!sol.datos.tienda && sol.estado === 'EN_CURSO'">{{ sol.datos.tienda ? (sol.datos.tienda.codigo + ' · ' + sol.datos.tienda.nombre + ' · Caja ' + sol.datos.tienda.caja + (sol.datos.tienda.ciudad ? ' · ' + sol.datos.tienda.ciudad : '')) : (sol.estado === 'EN_CURSO' ? 'Falta: la define el ejecutivo' : '—') }}</dd></div>
            </dl>
          </div>
        </div>

        <div class="as-par">
          <!-- Contactos -->
          <div class="kb-card">
            <div class="kb-card-header">
              <p class="kb-seccion-rotulo">Contactos · {{ sol.contactos.length }} <span class="as-quien">los carga el {{ quienLlena('CONTACTOS') }}</span></p>
              <a class="kb-btn kb-btn-outline kb-btn-sm !text-foreground" *ngIf="ofreceCompletar('CONTACTOS')"
                 [routerLink]="['/console/altas', id, 'cargar']" [queryParams]="{ paso: pasoDe('CONTACTOS') }">Completar</a>
            </div>
            <div class="kb-card-body">
              <p class="text-sm text-muted-foreground" *ngIf="!sol.contactos.length">Todavía no hay ningún contacto cargado.</p>
              <p class="text-sm kb-texto-alerta" *ngIf="sol.contactos.length && faltanContactos">{{ faltanContactos }}</p>
              <p class="kb-hint" *ngIf="sol.contactos.length">
                Si el comercio se integra por API o tiene tienda en línea, agrega el contacto técnico en
                «Contactos» (o márcale el papel Técnico a uno que ya esté): a él le llegan las claves.
              </p>
              <div class="as-contacto" *ngFor="let c of sol.contactos">
                <p class="as-contacto-nombre">
                  {{ c.nombre || '—' }}
                  <span class="kb-badge kb-badge-contorno" *ngFor="let p of papelesDe(c)">{{ nombrePapel(p) }}</span>
                </p>
                <p class="as-contacto-via">{{ c.correo || 'sin correo' }} · {{ c.telefono || 'sin teléfono' }}</p>
              </div>
            </div>
          </div>

          <!-- Condiciones: el resumen -->
          <div class="kb-card">
            <div class="kb-card-header">
              <p class="kb-seccion-rotulo">Condiciones <span class="as-quien">las carga el {{ quienLlena('CONDICIONES') }}</span></p>
              <a class="kb-btn kb-btn-outline kb-btn-sm !text-foreground" *ngIf="ofreceCompletar('CONDICIONES')"
                 [routerLink]="['/console/altas', id, 'cargar']" [queryParams]="{ paso: pasoDe('CONDICIONES') }">Completar</a>
            </div>
            <div class="kb-card-body" *ngIf="!sol.condiciones">
              <p class="text-sm text-muted-foreground">Todavía no hay condiciones: las carga el {{ quienLlena('CONDICIONES') }}.</p>
            </div>
            <div class="kb-card-body" *ngIf="sol.condiciones">
              <dl class="as-campos-2">
                <div class="kb-campo"><dt class="kb-campo-et">Plazo y comisión</dt><dd class="kb-campo-val">{{ plazoYComision(sol.condiciones) }}</dd></div>
                <div class="kb-campo"><dt class="kb-campo-et">Esquema de liquidación</dt><dd class="kb-campo-val">{{ modeloNegocioCondiciones(sol.condiciones) }}</dd></div>
                <div class="kb-campo as-campo-ancho"><dt class="kb-campo-et">Cobros</dt><dd class="kb-campo-val">{{ cobrosCondiciones(sol.condiciones) }}</dd></div>
                <div class="kb-campo as-campo-ancho"><dt class="kb-campo-et">Canales de venta</dt><dd class="kb-campo-val">{{ canalesTexto }}</dd></div>
                <div class="kb-campo as-campo-ancho" *ngIf="sol.condiciones.contract_reference"><dt class="kb-campo-et">Referencia del contrato</dt><dd class="kb-campo-val">{{ sol.condiciones.contract_reference }}</dd></div>
                <div class="kb-campo as-campo-ancho" *ngIf="sol.rige_desde && sol.estado === 'APROBADA'"><dt class="kb-campo-et">El comercio opera desde</dt><dd class="kb-campo-val">{{ (sol.rige_desde + '').slice(0, 10).split('-').reverse().join('/') }}</dd></div>
              </dl>
            </div>
          </div>
        </div>

        <!-- Cuenta bancaria (CONTRATO-PUESTA-EN-MARCHA.md, «C»): la llena el ejecutivo; al alta pasa
             a `payment_accounts` como la principal. -->
        <div class="kb-card">
          <div class="kb-card-header">
            <p class="kb-seccion-rotulo">Cuenta bancaria <span class="as-quien">la llena el {{ quienLlena('CUENTA') }}</span></p>
            <a class="kb-btn kb-btn-outline kb-btn-sm !text-foreground" *ngIf="ofreceCompletar('CUENTA')"
               [routerLink]="['/console/altas', id, 'cargar']" [queryParams]="{ paso: pasoDe('CUENTA') }">Completar</a>
          </div>
          <div class="kb-card-body" *ngIf="!sol.datos.cuenta?.numero">
            <p class="text-sm text-muted-foreground">Todavía no hay ninguna cuenta cargada.</p>
          </div>
          <div class="kb-card-body" *ngIf="sol.datos.cuenta?.numero as numero">
            <dl class="as-campos-2">
              <div class="kb-campo"><dt class="kb-campo-et">Banco</dt><dd class="kb-campo-val">{{ sol.datos.cuenta?.banco_nombre || '—' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Número</dt><dd class="kb-campo-val font-mono">{{ numero }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Tipo</dt><dd class="kb-campo-val">{{ sol.datos.cuenta?.tipo === 'AHORRO' ? 'Ahorro' : 'Corriente' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Moneda</dt><dd class="kb-campo-val">{{ sol.datos.cuenta?.moneda === 'USD' ? 'Dólares' : 'Bolívares' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">Titular</dt><dd class="kb-campo-val">{{ sol.datos.cuenta?.titular || '—' }}</dd></div>
              <div class="kb-campo"><dt class="kb-campo-et">RIF del titular</dt><dd class="kb-campo-val">{{ sol.datos.cuenta?.rif_titular || '—' }}</dd></div>
            </dl>
          </div>
        </div>

        <!-- Documentos: uno por tipo, con su estado y «Ver». Los `para: 'APROBAR'` NO frenan (§5). -->
        <div class="kb-card">
          <div class="kb-card-header">
            <p class="kb-seccion-rotulo">
              Documentos<ng-container *ngIf="sol.documentos?.length"> · {{ documentosCargados }} de {{ sol.documentos.length }}</ng-container>
              <span class="as-quien">{{ quienCargaDocumentos }}</span>
            </p>
            <a class="kb-btn kb-btn-outline kb-btn-sm !text-foreground" *ngIf="ofreceCompletar('DOCUMENTOS')"
               [routerLink]="['/console/altas', id, 'cargar']" [queryParams]="{ paso: pasoDe('DOCUMENTOS') }">Completar</a>
          </div>

          <!-- Si ya se aprobó sin alguno: qué faltaba, quién siguió igual y por qué. -->
          <div class="kb-card-body" *ngIf="sol.nota_documentos">
            <div class="kb-aviso kb-aviso-alerta">
              <i class="fas fa-exclamation-triangle mt-0.5" aria-hidden="true"></i>
              <p>
                Pasó sin: {{ nombresNotaDocumentos }}. Nota de {{ sol.nota_documentos.rol_nombre }}
                ({{ sol.nota_documentos.username }}): {{ sol.nota_documentos.texto }}
              </p>
            </div>
          </div>

          <div class="kb-card-body" *ngIf="!sol.documentos || !sol.documentos.length">
            <p class="text-sm text-muted-foreground">Este tipo de solicitud no tiene documentos configurados.</p>
          </div>

          <div class="kb-card-body" *ngIf="sol.documentos && sol.documentos.length">
            <div class="as-doc" *ngFor="let d of sol.documentos">
              <div class="as-doc-info">
                <p class="as-doc-nombre">
                  {{ d.nombre }}
                  <span class="kb-badge kb-badge-contorno">{{ d.para === 'CREAR' ? 'Para crear' : 'Para aprobar' }}</span>
                </p>
                <p class="as-doc-estado" *ngIf="d.cargado">
                  <span class="kb-texto-exito"><i class="fas fa-check-circle" aria-hidden="true"></i> {{ d.cargado.nombre_archivo }}</span>
                  <span class="as-doc-meta">{{ d.cargado.subido_por.username }} · {{ fechaHora(d.cargado.subido_at) }}</span>
                </p>
                <p class="as-doc-estado kb-texto-alerta" *ngIf="!d.cargado">Falta</p>
              </div>
              <div class="as-doc-acciones">
                <a class="kb-btn kb-btn-ghost kb-btn-sm !text-foreground" *ngIf="d.cargado"
                   [href]="urlDocumento(d.cargado.url)" target="_blank" rel="noopener">
                  <i class="fas fa-external-link-alt" aria-hidden="true"></i>Ver
                </a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- ─── Historial: comentar arriba, los movimientos por etapa debajo ─────────────────────── -->
      <ng-container *ngIf="pestana === 'historial'">
        <p class="as-panel-intro">Cada comentario y cada decisión quedan en la etapa donde se hicieron.</p>

        <div class="kb-card">
          <div class="kb-card-header">
            <p class="kb-seccion-rotulo">Comentar</p>
          </div>
          <div class="kb-card-body" *ngIf="sol.acciones.comentar">
            <label class="kb-label" for="asComentSeguimiento">Comentario de seguimiento <span class="as-quien">solo tú, mientras la tienes; no lleva adjuntos</span></label>
            <textarea id="asComentSeguimiento" rows="2" class="kb-textarea" [(ngModel)]="comentarioTexto" (ngModelChange)="guardarComentarios()"
                      placeholder="Por ejemplo: llamé al dueño, quedó en mandar la cédula el lunes."></textarea>
            <div class="flex justify-end mt-[12px]">
              <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" [disabled]="comentando || !comentarioListo" (click)="comentar()">
                <i class="fas fa-spinner fa-spin" *ngIf="comentando" aria-hidden="true"></i>Agregar comentario
              </button>
            </div>
          </div>
          <div class="kb-card-body" *ngIf="!sol.acciones.comentar">
            <p class="text-sm text-muted-foreground">{{ quienComenta }}</p>
          </div>
        </div>

        <div class="kb-card">
          <div class="kb-card-header">
            <p class="kb-seccion-rotulo">Movimientos · {{ eventos.length }}</p>
          </div>

          <!-- Juan, 2026-10-08: cada decisión dice QUÉ dejó listo ese perfil; lo menor, una línea gris;
               la puesta en marcha, con su resultado (antes salía un renglón suelto «El sistema»). -->
          <div class="as-historial" *ngIf="historialAgrupado.length">
            <ng-container *ngFor="let h of historialAgrupado">
              <p class="as-eta" *ngIf="h.cabecera">{{ h.cabecera }}</p>

              <ng-container [ngSwitch]="tipoDeRenglon(h.ev)">
                <!-- La decisión: tarjeta con su insignia y lo que dejó listo -->
                <div *ngSwitchCase="'decision'" class="as-dec" [ngClass]="'as-dec-' + h.ev.tipo.toLowerCase()">
                  <div class="as-dec-cab">
                    <span class="as-insignia">{{ insigniaDecision(h.ev.tipo) }}</span>
                    <span class="as-dec-quien">{{ quienEs(h.ev) }}{{ comoPerfilAdmin(h.ev) }}</span>
                    <span class="as-dec-rol" *ngIf="h.ev.etapa?.rol_nombre">{{ h.ev.etapa?.rol_nombre }}</span>
                    <span class="as-dec-rol" *ngIf="destinoTexto(h.ev)">→ {{ destinoTexto(h.ev).replace('y ', '') }}</span>
                    <span class="as-dec-f">{{ fechaHora(h.ev.at) }}</span>
                  </div>
                  <p class="as-dec-com" *ngIf="h.ev.comentario">{{ h.ev.comentario }}</p>
                  <p class="as-dec-com" *ngIf="h.ev.tipo === 'RECHAZADA' && h.ev.motivo">Motivo: {{ nombreMotivo(h.ev.motivo) }}</p>
                  <div class="as-dec-res" *ngIf="resumenDecision(h.ev).datos.length">
                    <p class="as-dec-res-rot">{{ resumenDecision(h.ev).titulo }}</p>
                    <dl class="as-dec-datos">
                      <div *ngFor="let d of resumenDecision(h.ev).datos" [class.as-falta]="d.falta">
                        <dt>{{ d.et }}</dt><dd>{{ d.val }}</dd>
                      </div>
                    </dl>
                    <p class="as-dec-nota" *ngIf="h.ev.data?.nota_documentos">
                      Pasó sin: {{ docsFaltantesTexto(h.ev) }}. Nota: «{{ h.ev.data.nota_documentos }}»
                    </p>
                  </div>
                </div>

                <!-- La puesta en marcha: el resultado, con cada paso -->
                <div *ngSwitchCase="'puesta'" class="as-sis">
                  <p class="as-sis-tit">{{ tituloPuesta(h.ev) }}</p>
                  <p class="as-sis-txt" *ngIf="h.ev.data?.error">Falló en «{{ h.ev.data?.paso }}»: <b>{{ h.ev.data?.error }}</b></p>
                  <div class="as-sis-pasos" *ngIf="pasosPuesta.length">
                    <span *ngFor="let p of pasosPuesta" class="as-sis-paso" [ngClass]="'as-sis-' + p.tono">{{ p.marca }} {{ p.nombre }}</span>
                  </div>
                  <div class="flex flex-wrap gap-2 mt-3">
                    <a class="kb-btn kb-btn-outline kb-btn-sm !text-foreground" *ngIf="sol.efecto?.detalle?.comercio as cm"
                       [routerLink]="['/console/merchants', cm.code]">Ver el comercio {{ cm.code }}</a>
                    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="irA('expediente')">Ir a la puesta en marcha</button>
                  </div>
                </div>

                <!-- Lo menor: una línea gris -->
                <div *ngSwitchCase="'menor'" class="as-mov">
                  <span class="as-ev-f">{{ fechaHora(h.ev.at) }}</span>
                  <span [ngSwitch]="h.ev.tipo">
                    <ng-container *ngSwitchCase="'CREADA'"><b>{{ quienEs(h.ev) }}</b> creó la solicitud</ng-container>
                    <ng-container *ngSwitchCase="'TOMADA'"><b>{{ quienEs(h.ev) }}</b> se la asignó</ng-container>
                    <ng-container *ngSwitchCase="'SOLTADA'"><b>{{ quienEs(h.ev) }}</b> la liberó</ng-container>
                    <ng-container *ngSwitchCase="'COMENTARIO'">
                      <b>{{ quienEs(h.ev) }}</b> comentó<span class="as-ev-c" *ngIf="h.ev.comentario">«{{ h.ev.comentario }}»</span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DATOS'"><b>{{ quienEs(h.ev) }}</b> cambió {{ camposTexto(h.ev) }}</ng-container>
                    <ng-container *ngSwitchCase="'DOCUMENTO'">
                      <b>{{ quienEs(h.ev) }}</b> {{ h.ev.data?.quitado ? 'quitó' : (h.ev.data?.reemplazo ? 'reemplazó' : 'subió') }}
                      {{ h.ev.data?.nombre | lowercase }} · {{ h.ev.data?.nombre_archivo }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'CONDICIONES'"><b>{{ quienEs(h.ev) }}</b> guardó las condiciones</ng-container>
                    <ng-container *ngSwitchCase="'ALTA'">
                      <span class="kb-texto-peligro">El alta del comercio no se pudo completar: {{ h.ev.data?.error }}</span>
                    </ng-container>
                    <ng-container *ngSwitchDefault>{{ quienEs(h.ev) }} · {{ h.ev.tipo | lowercase }}</ng-container>
                  </span>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="kb-card-body" *ngIf="!historialAgrupado.length">
            <p class="text-sm text-muted-foreground">Todavía no hay ningún evento.</p>
          </div>
        </div>
      </ng-container>

      <!-- ─── Decisión: solo si la tienes ──────────────────────────────────────────────────── -->
      <ng-container *ngIf="pestana === 'decision'">
        <p class="as-panel-intro">Toda decisión lleva un comentario: es lo que queda en el historial.</p>

        <div class="kb-card" *ngIf="!puedeDecidir">
          <div class="kb-card-body">
            <p class="text-sm text-muted-foreground">{{ porQueNoDecide }}</p>
          </div>
        </div>

        <div class="kb-card" *ngIf="puedeDecidir">
          <div class="kb-card-body as-decision">

            <!-- Lo que falta: lo que frena aprobar y los documentos (que no frenan), con su paso -->
            <div class="kb-aviso kb-aviso-alerta" *ngIf="faltas.length">
              <i class="fas fa-exclamation-triangle mt-0.5" aria-hidden="true"></i>
              <div class="as-faltas">
                <p class="kb-aviso-titulo">Lo que falta para aprobar</p>
                <div class="as-falta" *ngFor="let f of faltas">
                  <span>{{ f.texto }}</span>
                  <a class="as-falta-enlace" *ngIf="f.paso" [routerLink]="['/console/altas', id, 'cargar']" [queryParams]="{ paso: f.paso }">Completarlo</a>
                  <span class="text-muted-foreground" *ngIf="!f.paso && f.quien">(lo completa el {{ f.quien }})</span>
                </div>
              </div>
            </div>

            <div>
              <p class="kb-label">Tu decisión</p>
              <div class="as-opc" role="radiogroup" aria-label="Tu decisión">
                <label [class.as-opc-on]="decision === 'APROBAR'" [class.as-opc-off]="!opcionHabilitada('APROBAR')">
                  <input type="radio" name="asDecision" [checked]="decision === 'APROBAR'"
                         [disabled]="!opcionHabilitada('APROBAR')" (change)="elegirDecision('APROBAR')">
                  <span>Aprobar<small>{{ textoOpcionAprobar }}</small></span>
                </label>
                <label [class.as-opc-on]="decision === 'DEVOLVER'" [class.as-opc-off]="!opcionHabilitada('DEVOLVER')">
                  <input type="radio" name="asDecision" [checked]="decision === 'DEVOLVER'"
                         [disabled]="!opcionHabilitada('DEVOLVER')" (change)="elegirDecision('DEVOLVER')">
                  <span>Devolver<small>{{ textoOpcionDevolver }}</small></span>
                </label>
                <label [class.as-opc-on]="decision === 'RECHAZAR'" [class.as-opc-off]="!opcionHabilitada('RECHAZAR')">
                  <input type="radio" name="asDecision" [checked]="decision === 'RECHAZAR'"
                         [disabled]="!opcionHabilitada('RECHAZAR')" (change)="elegirDecision('RECHAZAR')">
                  <span>Rechazar<small>{{ textoOpcionRechazar }}</small></span>
                </label>
              </div>
            </div>

            <div class="as-decision-campos">
              <div class="as-decision-motivo" *ngIf="decision === 'RECHAZAR'">
                <label class="kb-label" for="asMotivo">Motivo</label>
                <div class="kb-select-envoltorio">
                  <select id="asMotivo" class="kb-select" [(ngModel)]="motivoRechazo">
                    <option value="">Elige un motivo…</option>
                    <option *ngFor="let m of motivosList" [value]="m.codigo">{{ m.nombre }}</option>
                  </select>
                  <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                </div>
              </div>

              <div>
                <label class="kb-label" for="asComentDecision">Comentario de tu decisión</label>
                <textarea id="asComentDecision" rows="3" class="kb-textarea" [(ngModel)]="comentarioDecision" (ngModelChange)="guardarComentarios()"
                          placeholder="Lo que queda escrito en el historial."></textarea>
                <p class="kb-hint" *ngIf="!comentarioDecisionValido">Al menos 3 letras: es lo mínimo para poder decidir.</p>
              </div>

              <!-- Cambio de Juan (§5): los documentos para aprobar NO frenan, pero si faltan, seguir
                   exige esta nota. Se manda como `nota_documentos`. -->
              <!-- Juan, 2026-10-08: el último perfil elige desde cuándo opera el comercio (el «rige desde» de
                   sus condiciones). Sólo al aprobar y sólo en la última etapa. -->
              <div class="as-rige" *ngIf="decision === 'APROBAR' && sol.pide_rige_desde">
                <label class="kb-label" for="asRigeDesde">El comercio opera desde <span class="kb-texto-peligro">*</span></label>
                <input id="asRigeDesde" type="date" class="kb-input tabular-nums max-w-[220px]" [min]="hoyCaracas" [(ngModel)]="rigeDesde">
                <p class="kb-hint" *ngIf="!rigeDesde">Desde ese día rigen sus condiciones y puede vender. Hoy o después.</p>
                <p class="kb-hint kb-texto-peligro" *ngIf="rigeDesde && !rigeDesdeValida">Tiene que ser hoy o una fecha futura.</p>
                <p class="kb-hint kb-texto-exito" *ngIf="rigeDesdeValida">Al aprobar nace el comercio; puede vender desde el {{ rigeDesdeTexto }}.</p>
              </div>

              <div *ngIf="notaDocumentosRequerida">
                <label class="kb-label" for="asNotaDocumentos">Nota de los documentos que faltan <span class="kb-texto-peligro">*</span></label>
                <textarea id="asNotaDocumentos" rows="2" class="kb-textarea" [(ngModel)]="notaDocumentos" (ngModelChange)="guardarComentarios()"
                          placeholder="Por qué se sigue sin: {{ nombresDocumentosFaltantes }}."></textarea>
                <p class="kb-hint" *ngIf="!notaDocumentosValida">Al menos 10 letras: es obligatoria para aprobar sin los documentos.</p>
              </div>
            </div>

            <div class="flex justify-end" *ngIf="!confirmandoRechazo">
              <button type="button" class="kb-btn kb-btn-primary" [disabled]="decidiendo || !decisionValida" (click)="alDecidir()">
                <i class="fas fa-spinner fa-spin" *ngIf="decidiendo" aria-hidden="true"></i>{{ textoBotonDecision }}
              </button>
            </div>
            <div class="flex flex-wrap items-center justify-end gap-2" *ngIf="confirmandoRechazo">
              <span class="text-sm kb-texto-peligro">¿Rechazar esta solicitud? No se puede deshacer.</span>
              <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="decidiendo" (click)="cancelarRechazo()">Cancelar</button>
              <button type="button" class="kb-btn kb-btn-danger kb-btn-sm" [disabled]="decidiendo" (click)="alDecidir()">
                <i class="fas fa-spinner fa-spin" *ngIf="decidiendo" aria-hidden="true"></i>Sí, rechazar la solicitud
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

  </ng-container>
</div>
